<template>
  <div
    v-if="event.categories.length === 0"
    class="flex flex-col md:flex-row justify-between items-center"
  >
    <img class="mb-10 md:mb-0 w-1/2 md:w-1/5" src="@/assets/images/undraw_create_f05x.svg" />

    <div class="flex flex-col md:ml-12">
      <h4 class="text-xl leading-6 text-gray-900">Noch keine Tickets angelegt</h4>
      <p class="mt-2 mb-6 text-base leading-6 text-gray-500">
        Lege als erstes eine Kategorie fest um Tickets angelegen zu können. Eine Kategorie kann
        etwas sein wie
        <span class="font-medium">Freie Platzwahl</span> für ein Konzert,
        <span class="font-medium">Eintritt</span> für eine Party und so weiter. Danach kannst du
        deine Tickets anlegen wie zum Beispiel Standard oder Ermäßigt.
      </p>

      <basic-button
        @click="createCategoryModal()"
        class="mt-auto"
        leading-icon="rocket-launch"
        size="lg"
        >Kategorie anlegen</basic-button
      >
    </div>
  </div>
  <div v-else>
    <div class="text-xl">Tickets und Kontingente</div>
    <div>
      <draggable
        :list="event.categories"
        handle=".handle"
        :forceFallback="true"
        @change="orderCategories()"
      >
        <category
          v-for="(category, categoryKey) in event.categories"
          :key="category.id ? category.id : category._id"
          :categoryProp="category"
          @destroyed="destroyCategory(categoryKey)"
        >
          <draggable
            :list="category.types"
            handle=".handle"
            :group="{ name: 'types' }"
            :forceFallback="true"
            ghostClass="bg-gray-300"
            :emptyInsertThreshold="100"
            class="min-h-20 empty-draggable-container"
            @change="orderTypes(categoryKey)"
          >
            <span v-for="(type, typeKey) in category.types" :key="type.id ? type.id : type._id">
              <Type
                v-if="!type.is_free"
                :type="type"
                :errors="errors"
                :error-key="`categories.${categoryKey}.types.${typeKey}`"
                :ticket-fees="event.ticket_fees"
                @destroyed="destroyType(categoryKey, typeKey)"
              ></Type>
              <TypeIsFree
                v-else
                :type="type"
                :errors="errors"
                :error-key="`categories.${categoryKey}.types.${typeKey}`"
                :ticket-fees="event.ticket_fees"
                @destroyed="destroyType(categoryKey, typeKey)"
              />
            </span>
          </draggable>
          <div class="w-full justify-center">
            <basic-button
              @click="createType(categoryKey)"
              leading-icon="plus"
              color="white"
              class="m-3"
              >Ticket anlegen</basic-button
            >
          </div>
        </category>
      </draggable>
    </div>

    <basic-button leading-icon="plus" color="white" @click="createCategoryModal()" class="mt-3"
      >Weitere Kategorie anlegen</basic-button
    >
  </div>
</template>


<script>
import Draggable from 'vuedraggable';
import Type from '@/components/editor/Type';
import TypeIsFree from '@/components/editor/TypeIsFree';
import Category from '@/components/editor/Category';
import CreateCategoryModal from '@/components/modals/CreateCategoryModal';

import _each from 'lodash/each';

export default {
  components: {
    Draggable,
    Type,
    Category,
    TypeIsFree,
  },

  props: { event: Object, errors: Object },

  methods: {
    orderTypes(categoryKey) {
      let i = 1;

      _each(this.event.categories[categoryKey].types, (type) => {
        type.sequence = i;
        i++;
      });
    },
    orderCategories() {
      let i = 1;

      _each(this.event.categories, (category) => {
        category.sequence = i;
        i++;
      });
    },
    createCategoryModal() {
      this.$modal.show(CreateCategoryModal, {
        createFunc: this.createCategory,
      });
    },
    createCategory(category) {
      this.event.categories.push({
        _id: this.uuidv4(),
        sequence: this.event.categories.length + 1,
        types: [],
        ...category,
      });
    },
    createType(categoryId) {
      this.event.categories[categoryId].types.push({
        _id: this.uuidv4(),
        title: '',
        price_agency: null,
        price_online: null,
        min_amount_per_order: 1,
        max_amount_per_order: 10,
        published_agency: true,
        published_online: true,
        published_from: { utc: null },
        published_to: { utc: this.event.start_date.utc },
        sequence: this.event.categories[categoryId].types.length + 1,
        editable: true,
      });
    },
    createFreeType(categoryId) {
      this.event.categories[categoryId].types.push({
        _id: this.uuidv4(),
        title: '',
        price_agency: null,
        price_online: 0,
        min_amount_per_order: 1,
        max_amount_per_order: 10,
        published_agency: false,
        published_online: true,
        published_from: { utc: null },
        published_to: { utc: this.event.start_date.utc },
        sequence: this.event.categories[categoryId].types.length + 1,
        is_free: true,
        editable: true,
      });
    },
    destroyType(categoryKey, typeKey) {
      this.event.categories[categoryKey].types.splice(typeKey, 1);
    },
    destroyCategory(categoryKey) {
      this.event.categories.splice(categoryKey, 1);
    },
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
  },
};
</script>

<style scoped>
.empty-draggable-container:empty {
  @apply .border-2 .border-dashed .rounded .m-5;
}
</style>
